"use strict";

exports.__esModule = true;
exports.legacyToSettingsResponse = void 0;
var _legacyToSettingsBusinessInfo = require("../businessInfo/legacyToSettingsBusinessInfo");
var _legacyToSettingsFeatures = require("../activeFeature/legacyToSettingsFeatures");
var _businessInfo = require("../businessInfo/businessInfo");
const legacyToSettingsResponse = legacy => {
  const info = (0, _businessInfo.getBusinessInfo)(legacy);
  const isMultiServiceAppointmentsEnabled = (0, _businessInfo.isPropertyEnabled)(legacy, _businessInfo.BusinessPropertyName.MULTI_SERVICES_APPOINTMENTS);
  const isCartEnabled = (0, _businessInfo.isPropertyEnabled)(legacy, _businessInfo.BusinessPropertyName.IS_CART_ENABLED);
  const customProperties = (0, _businessInfo.getCustomProperties)(legacy);
  const bookingsSettings = {
    siteProperties: (0, _legacyToSettingsBusinessInfo.legacyToBookingsSettings)(legacy).siteProperties,
    displayTimeZone: (0, _legacyToSettingsBusinessInfo.legacyToBookingsSettings)(legacy).displayTimeZone,
    features: (0, _legacyToSettingsFeatures.legacyToSettingsFeatures)(legacy.activeFeatures),
    extendedFields: {
      customProperties: [...((customProperties == null ? void 0 : customProperties.map(prop => ({
        namespaces: {
          [prop.propertyName ?? '']: prop.value ?? ''
        }
      }))) ?? []), {
        namespaces: {
          ...(info != null && info.businessType ? {
            ['business type']: [info == null ? void 0 : info.businessType]
          } : {}),
          ...(info != null && info.premiumInfo ? {
            ['premium info']: [info == null ? void 0 : info.premiumInfo]
          } : {})
        }
      }]
    },
    cartCheckout: {
      enabled: isCartEnabled
    },
    multiServiceAppointments: {
      enabled: isMultiServiceAppointmentsEnabled
    }
  };
  return {
    bookingsSettings
  };
};
exports.legacyToSettingsResponse = legacyToSettingsResponse;
//# sourceMappingURL=legacyToSettingsResponse.js.map